// extracted by mini-css-extract-plugin
export var divider = "_tw-0";
export var systemMessage = "_tw-1";